import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Translation } from 'react-i18next';

import { connect } from 'react-redux';
import { patchUser } from 'redux/settings/actions';

import onClickOutside from 'react-onclickoutside';

import InputField from 'components/elements/InputField';

import './UserTitle.css';


const ENTER_KEY = 13;

class UserTitle extends Component {
  static propTypes = {
    patchUser: PropTypes.func.isRequired,
    me: PropTypes.object,
  }

  static defaultProps = {
    me: null,
  }

  state = {
    initialValue: null,
    currentValue: null,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.onEnterClick);
    this.setState({
      initialValue: this.props.me.title,
      currentValue: this.props.me.title,
    });
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onEnterClick);
  }

  handleClickOutside = () => {
    this.changeTitle();
  };

  onEnterClick = event => {
    if (event.keyCode === ENTER_KEY) {
      this.changeTitle();
    }
  };

  changeTitle = () => {
    const { initialValue, currentValue } = this.state;

    if (
      currentValue !== '' &&
      currentValue !== initialValue
    ) {
      this.setState({ initialValue: currentValue});
      const form = new FormData();
      form.append('title', currentValue);
      this.props.patchUser(form);
    }
  };

  render() {
    const { currentValue } = this.state;

    return (
      <Translation>
        {(t) => (
          <div className="user-title__component">
            <InputField
              value={this.state.currentValue}
              onChange={(e) => {
                e.preventDefault();
                this.setState({ currentValue: e.target.value });
              }}
              error={currentValue === '' ? { id: 'user-title-error', text: t("Please enter Title") } : null}
            />
          </div>
        )}
      </Translation>
    );
  }
}

const mapStateToProps = state => (
  {
    me: state.usersReducer.me,
  }
);

export default connect(
  mapStateToProps,
  {
    patchUser,
  },
)(onClickOutside(UserTitle));
